import { StrictMode } from 'react';
import { ProjectsProvider } from './context/ProjectsContext';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HomeProvider } from './context/HomeContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ProjectsProvider>
      <HomeProvider>
        <App />
      </HomeProvider>
    </ProjectsProvider>
  </StrictMode>,
);
